module.exports = __webpack_public_path__ + "media/images/application/template/star-f43a660a50d622269c48a682c7a6bbeb.svg";